import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import Typography from '@mui/material/Typography'
import { useStyles } from './FundingBreadcrumb.styles'

interface FundingBreadcrumbProps {
  current: string
}

const DASHBOARD_PATH = '/funding'

export const FundingBreadcrumb = ({ current }: FundingBreadcrumbProps) => {
  const { classes } = useStyles()
  const navigate = useNavigate()
  const goToDashboard = () => navigate(DASHBOARD_PATH)

  return (
    <span className={classes.breadcrumb}>
      <button type="button" className={classes.link} onClick={goToDashboard}>
        Funding requests
      </button>
      <FontAwesomeIcon icon={faChevronRight} className={classes.separator} />
      <Typography component="span" className={classes.current}>
        {current}
      </Typography>
    </span>
  )
}
